import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Version } from './version.model';

@Injectable()
export class VersionService {
  constructor(private http: HttpClient) {}
  /**
   * Shows the list of versions
   */
  getVersionsList(projectId: number) {
    return this.http.get<Version[]>(
      `${environment.apiConfig.url}/deployments/project/${projectId}`,
    );
  }
}
